var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 45,
    viewBox: "-3 0 60 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33574 27.5786H4.14232V34.1033C4.14232 34.6415 4.47653 35.1121 4.94406 35.3138C5.07784 35.3809 5.27827 35.4485 5.47871 35.4485C5.81292 35.4485 6.14713 35.3138 6.41421 35.045L13.765 27.5786H16.3711V35.045C16.3711 35.7849 16.9724 36.3902 17.7075 36.3902H42.098L50.1839 44.5965C50.451 44.8653 50.7852 45 51.1194 45C51.3198 45 51.4536 45 51.654 44.8653C52.1887 44.6636 52.4558 44.1925 52.4558 43.6548L52.4562 36.4577H55.6637C56.3987 36.4577 57 35.8524 57 35.1125V7.7357C57 6.99576 56.3987 6.39052 55.6637 6.39052H37.2872V1.34565C37.2872 0.605709 36.6859 0.000469203 35.9509 0.000469203L1.33635 0C0.601267 0 0 0.605276 0 1.34518V26.2332C0 26.9736 0.601768 27.5789 1.33635 27.5789L1.33574 27.5786ZM54.3935 33.767H51.1861C50.451 33.767 49.8498 34.3723 49.8498 35.1122V40.4935L43.6354 34.1705C43.3683 33.9016 43.0341 33.7669 42.6999 33.7669H19.0444V9.08071H54.3272V33.7669L54.3935 33.767ZM2.67221 2.69059H34.6138V6.39028H17.7075C16.9724 6.39028 16.3711 6.99555 16.3711 7.73546V24.888H13.2304C12.8962 24.888 12.562 25.0227 12.2949 25.2915L6.81516 30.8075V26.2337C6.81516 25.4938 6.21386 24.8885 5.47881 24.8885H2.67223L2.67221 2.69059Z",
    fill: "#1E0039"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.a40e3d2f51ca8ae61f3bf94be5783219.svg";
export { ForwardRef as ReactComponent };